import { uuidv7 } from "uuidv7";

// Client-generated idempotency key. v7 is time-ordered, which keeps the offline
// command outbox naturally sortable/debuggable (event-model §11).
export const newId = (): string => uuidv7();
